import { render, staticRenderFns } from "./opening.vue?vue&type=template&id=c167828c&scoped=true"
import script from "./opening.vue?vue&type=script&lang=js"
export * from "./opening.vue?vue&type=script&lang=js"
import style0 from "./opening.vue?vue&type=style&index=0&id=c167828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c167828c",
  null
  
)

export default component.exports